import React, {useEffect, useState} from 'react';
import {Button, Stack, Typography} from "@mui/material";
import {Form, Formik} from 'formik';
import CreateInventoryForm from '../forms/CreateInventoryForm';
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {enGB} from 'date-fns/locale'
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import createInventoryModel, { createInventoryModelType } from '../models/createInventoryModel';
import LoadingCover from '../../common/LoadingCover';
import { Inventory, usePostInventoriesMutation} from '../../../redux/vmsApi';

type MyFormValues = createInventoryModelType

const createInventoryModelInitial = createInventoryModel.initialValues

type Props = {
  onSuccess?: (Inventory: Inventory) => void;
};

const CreateInventoryPage: React.FC<Props> = ({onSuccess}) => {
  const [createInventory, {isSuccess, isLoading}] = usePostInventoriesMutation();
  const [showOverlay, setShowOverlay] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);

  useEffect(() => {
    setShowOverlay(isLoading || isSuccess);
    if (isSuccess) {
      setTimeout(() => {
        setShowOverlay(false)
        setShowSuccessMsg(true)
      }, 3000);
    }
  }, [isLoading, isSuccess]);

  const initialValues: MyFormValues = {
    ...createInventoryModelInitial,
  };

  

  const handleSubmit = async (values: MyFormValues) => {
   
    const newInventory = {
        inventoryCode: values.inventoryCode,
        description: values.description,      
    }
   
    setShowOverlay(true)
    try {
      const result = await createInventory({newInventory}).unwrap();
      setShowOverlay(false);
      setShowOverlay(false);
      
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
     
      setShowOverlay(false);
      console.error("Error submitting form:", error);
    }
  }

  if (showSuccessMsg) {
    return (
      <Typography>Thank you, your response has been received</Typography>
    )
  }

  return (
    <React.Fragment>
      {showOverlay && <LoadingCover isSuccess={isSuccess}/>}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleSubmit}
        
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
          <Form>
            <Stack spacing={4} width="100%" p={10} pb={5}>
              <CreateInventoryForm/>
              <Button
                variant="contained"
                type="submit"
              >
                Submit
              </Button>
            </Stack>
          </Form>
        </LocalizationProvider>
      </Formik>
      </React.Fragment>
  )
}

export default CreateInventoryPage;
